import React, { useState, useEffect, useRef, useContext } from "react";
import { useHistory } from "react-router-dom";
import { OrderService } from "../../../services/order-service";
import { DataGrid } from "@material-ui/data-grid";
import { Button, Modal } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import TablePagination from "@material-ui/core/TablePagination";
import AuthContext from "../../../context/auth-context";
import moment from "moment";
import { TextField } from "@material-ui/core";

export const OrderNewtable = () => {
  const ctx = useContext(AuthContext);

  const authPermission = localStorage.getItem("PermissionDetails");

  const [editHide, setHideEdit] = useState(true);
  const [deleteHide, setHideDelete] = useState(true);
  const [reviewHide, setHideReview] = useState(false);
  const [courierHide, setHideCourier] = useState(false);

  useEffect(() => {
    JSON.parse(authPermission).forEach(function (loca) {
      if (
        loca.access_module.module_name == "ORDER_2" &&
        loca.permission_edit === true
      ) {
        setHideEdit(false);
      }
      if (
        loca.access_module.module_name == "ORDER_2" &&
        loca.permission_delete === true
      ) {
        setHideDelete(false);
      }

      if (
        loca.access_level.access_level == "ADMIN"
      ) {
        setHideCourier(true);
      }

      if (
        loca.access_level.access_level == "STORE_ADMIN_USER"
      ) {
        setHideReview(true);
      }

    });
  }, [authPermission]);

  const format2 = "YYYY-MM-DD HH:mm:ss";

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [count, setDataCount] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [nameSearchTerm, setNameSearchTerm] = useState("");
  const [phoneSearchTerm, setPhoneSearchTerm] = useState("");

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeSearchTerm = (event) => {
    const value = event.target.value.trim();
    setSearchTerm(value);

  };

  const handleChangeNameSearchTerm = (event) => {
    const value = event.target.value;
    setNameSearchTerm(value);
  };

  const handleChangePhoneSearchTerm = (event) => {
    const value = event.target.value.trim();
    setPhoneSearchTerm(value);
  };

  const history = useHistory();
  const [orders, setOrderDetails] = useState([]);
  const [orderID, setorderID] = useState();
  const [statusname, setStatusValue] = useState("");
  const [paymentMethod, setPaymentMethodValue] = useState("");
  const [paymentStatus, setPaymentStatusValue] = useState("");
  const [state, setState] = useState(false);
  const [submitloading, setSubmitLoading] = useState(true);
  const [key, setKey] = useState(0);
  const [isSending, setIsSending] = useState(false);

  const handleShow4 = (e) => {
    setState({ show4: true });
    setorderID(e);
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };

  const clearFilters = () => {
    setSearchTerm("");
    setNameSearchTerm("");
    setPhoneSearchTerm("");
    setStatusValue("");
    setPaymentMethodValue("");
    setPaymentStatusValue("");
    setPage(0);
    setRowsPerPage(10);
  };

  useEffect(() => {
    orderSearch();
  }, [searchTerm, nameSearchTerm, phoneSearchTerm, statusname, paymentMethod, paymentStatus, rowsPerPage, page, count]);

  const orderSearch = async () => {
    try {

      const result = await OrderService.randomOrderDetails(
        [{"searchTerm": searchTerm}, {"nameSearchTerm": nameSearchTerm}, {"phoneSearchTerm": phoneSearchTerm},{"statusname": statusname},{"paymentMethod": paymentMethod},{"paymentStatus": paymentStatus}, {"type": 'CURRIER'}],
        rowsPerPage,
        page
      );

      // Add unique id to each order if not already present
      const ordersWithId = result.results.map((order, index) => ({
        ...order,
      }));

      setOrderDetails(ordersWithId);
      setDataCount(result?.pagination?.total);
      setKey(prevKey => prevKey + 1);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  const onDelete = async () => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      await OrderService.orderDelete(orderID);

      setSubmitLoading(true);
      notify("Order successfully deleted");
      handleClose();
      orderSearch();
    } catch (err) {
      notifyWarning(err.response.data.message);
      setSubmitLoading(true);
      //show error toast
    }
  };

  const [selectedItems, setSelectedItems] = useState([]);

  // Handle checkbox change
  const handleCheckboxChange = (id) => {
    setSelectedItems((prevSelectedItems) =>
      prevSelectedItems.includes(id)
        ? prevSelectedItems.filter((itemId) => itemId !== id)
        : [...prevSelectedItems, id]
    );
  };

  


  const handleClick = async () => {
    setIsSending(true);

    try {
      const response = await OrderService.sendBulkReviewSms(selectedItems);
    const failedOrderIds = response.filter(order => order.status === 'failed').map(order => order.orderId);

      if(failedOrderIds.length > 0){
        setSelectedItems(failedOrderIds);
        notifyWarning("Failed to send SMS for selected orders");
        
      }else{
        notify("All SMS sent successfully");
      }
    } catch (error) {
      console.error("Error sending SMS:", error);
    } finally {
      setIsSending(false);
    }
  };

  const columns = [
    {
      field: "order_date",
      headerName: "Date",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>{moment(params.row.order_date).add(5, 'hours').add(30, 'minutes').format(format2)}</div>;
      },
    },
    {
      field: "random_id",
      headerName: "Order Id",
      flex: 3,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>#{params.row.random_id} - {params.row.user.name} </div>;
      },
    },
    // {
    //   field: "total_items",
    //   headerName: "Total Items",
    //   flex: 3,
    //   cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    //   headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    // },
    {
      field: "total",
      headerName: "Price(Rs.)",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "payment_method",
      headerName: "Payment Method",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        if (params.row.payment_method === "CASH_ON_DELIVERY") {
          return (
            <div>
              {" "}
              <span>COD</span>
            </div>
          );
        } else if(params.row.payment_method === "PAYHERE") {
          return (
            <div>
              {" "}
              <span>PH</span>
            </div>
          );
        }else{
          return (
            <div>
              {" "}
              <span>BD</span>
            </div>
          );
        }
      }
    },
    {
      field: "payment_status",
      headerName: "Payment Status",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        if (params.row.payment_status === "PENDING") {
          return (
            <div>
              {" "}
              <span className="badge badge-warning">PENDING</span>
            </div>
          );
        } else if (params.row.payment_status === "APPROVED") {
          return (
            <div>
              {" "}
              <span className="badge badge-success">APPROVED</span>
            </div>
          );
        } else if (params.row.payment_status === "CANCELED") {
          return (
            <div>
              <span className="badge badge-danger">CANCELED</span>
            </div>
          );
        } else if (params.row.payment_status === "FAILED") {
          return (
            <div>
              <span className="badge badge-primary">FAILED</span>
            </div>
          );
        } else {
          return (
            <div>
              <span className="badge badge-dark">CHANGEBACK</span>
            </div>
          );
        }
      },
    },
    // {
    //   field: "created_at",
    //   headerName: "Created Date",
    //   flex: 4,
    //   cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    //   headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    //   renderCell: (params) => {
    //     return <div>{moment(params.row.created_at).format(format2)}</div>;
    //   },
    // },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      flex: 2,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        const handleClick = () => {
          window.open(`${window.location.origin}/edit-order/${params.row.random_id}`, '_blank');

        };
        if (params.row.status === "PENDING") {
          return (
            <div onClick={handleClick} style={{ cursor: "pointer" }}>
              <span className="badge badge-warning">PENDING</span>
            </div>
          );
        } else if (params.row.status === "PREPARING") {
          return (
            <div onClick={handleClick} style={{ cursor: "pointer" }}>
              <span className="badge badge-light">READY TO SHIP</span>
            </div>
          );
        } else if (params.row.status === "DELIVERING") {
          return (
            <div onClick={handleClick} style={{ cursor: "pointer" }}>
              <span className="badge badge-secondary">SHIPPED</span>
            </div>
          );
        } else if (params.row.status === "COMPLETED") {
          return (
            <div onClick={handleClick} style={{ cursor: "pointer" }}>
              <span className="badge badge-success">COMPLETED</span>
            </div>
          );
        } else {
          return (
            <div onClick={handleClick} style={{ cursor: "pointer" }}>
              <span className="badge badge-danger">CANCELED</span>
            </div>
          );
        }
      },
    },
    {
        field: "review",
        headerName: "review",
        flex: 1,
        cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
        headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
        renderCell: (params) => {
          if (params.row.sent_reviewed === false && params.row.status === "DELIVERING") {
            return (
              <div hidden={reviewHide}>
                  <input
                      type="checkbox"
                      checked={selectedItems.includes(params.row.id)}
                      onChange={() => handleCheckboxChange(params.row.id)}
                  />
              </div>
              );
          }else{
            return (
              <div hidden={reviewHide}>
                  <input
                      type="checkbox"
                      disabled={true}
                      onChange={() => handleCheckboxChange(params.row.id)}
                  />
              </div>
              );
          }
        },
      },
    {
      field: "edit",
      headerName: "Edit",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div
            onClick={() => {
              history.push(`/edit-order/${params.row.random_id}`);
            }}
            style={{ cursor: "pointer" }}
            hidden={editHide}
          >
            <i className="fas fa-pencil-alt text-secondary" />
          </div>
        );
      },
    },
    // {
    //   field: "delete",
    //   headerName: "Delete",
    //   sortable: false,
    //   flex: 1,
    //   disableClickEventBubbling: true,
    //   headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    //   renderCell: (params) => {
    //     return (
    //       <div hidden={deleteHide}>
    //         <i
    //           className="far fa-trash-alt ms-text-danger"
    //           // onClick={handleShow4}
    //           onClick={() => {
    //             handleShow4(params.row.id);
    //           }}
    //           style={{ cursor: "pointer" }}
    //         />
    //       </div>
    //     );
    //   },
    // },
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className="col-xl-12">
              <div className="ms-panel">
                <div className="ms-panel-header">
                  <div className="row">
                    <div className="col-md-11">
                      <h6>Order List</h6>
                    </div>
                    <div>
                      <Modal
                        show={state.show4}
                        onHide={handleClose}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                      >
                        <Modal.Header>
                          <h3 className="modal-title has-icon ms-icon-round ">
                            Confirm Deletion
                          </h3>
                          <button
                            type="button"
                            className="close"
                            onClick={handleClose}
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </Modal.Header>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "2vh",
                          }}
                        >
                          <h6 style={{ color: "red" }}>
                            Are you sure you want to remove this item ?
                          </h6>
                        </div>
                        <Modal.Footer>
                          <div className="col-md-2" hidden={submitloading}>
                            <div className="spinner spinner-7">
                              <div className="bounce1" />
                              <div className="bounce2" />
                              <div className="bounce3" />
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn btn-primary shadow-none"
                            // onClick={submitForm}
                            style={{ backgroundColor: "red" }}
                            onClick={onDelete}
                          >
                            Delete
                          </button>

                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={handleClose}
                          >
                            Cancel
                          </button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                    {/* <div className="col-md-1">
                      {" "}
                      <div className="col-md-2 col-sm-4">
                        <button
                          type="button"
                          className="ms-btn-icon btn-primary"
                          name="button"
                          onClick={handleShow3}
                        >
                          <i className="material-icons">person_add</i>{" "}
                        </button>
                      </div>
                      <Modal
                        show={state.show3}
                        onHide={handleClose}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                      >
                        <Modal.Header>
                          <h3 className="modal-title has-icon ms-icon-round ">
                            <i className="flaticon-share bg-primary text-white" />{" "}
                            Add
                          </h3>
                          <button
                            type="button"
                            className="close"
                            onClick={handleClose}
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </Modal.Header>
                        <Formik
                          initialValues={{
                            term: "",
                            important: chView,
                          }}
                          validationSchema={Yup.object().shape({
                            term: Yup.string().required("Required"),

                           
                          })}
                          onSubmit={onSubmitForm}
                          innerRef={formRef}
                        >
                          {({
                            errors,
                            handleBlur,
                            handleChange,
                            touched,
                            values,
                            submitForm,
                            isValid,
                          }) => (
                            <div>
                              <Modal.Body>
                                <div className="mb-3">
                                  <label htmlFor="validationCustom08">
                                    Term
                                  </label>
                                  <div className="input-group">
                                    <input
                                      name="term"
                                      type="text"
                                      className="form-control"
                                      id="termID"
                                      placeholder="Term"
                                      required
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.term}
                                    />
                                  </div>
                                  <div
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {touched.term && errors.term}
                                  </div>
                                </div>

                                <div className="form-row">
                                  <label htmlFor="validationCustom18">
                                    Value
                                  </label>
                                  <div className="col-md-12 mb-6">
                                    <label className="ms-switch">
                                      <input
                                        checked={chView}
                                        value={chView}
                                        onChange={handleChangeView}
                                        type="checkbox"
                                        name="important"
                                        className="form-control"
                                        id="importantID"
                                        onBlur={handleBlur}
                                      />{" "}
                                      <span className="ms-switch-slider round" />
                                    </label>
                                  </div>
                                </div>

                                <div
                                  className="col-md-2"
                                  hidden={submitloading}
                                >
                                  <div className="spinner spinner-7">
                                    <div className="bounce1" />
                                    <div className="bounce2" />
                                    <div className="bounce3" />
                                  </div>
                                </div>
                              </Modal.Body>

                              <Modal.Footer>
                                <button
                                  type="button"
                                  className="btn btn-light"
                                  onClick={handleClose}
                                >
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-primary shadow-none"
                                  onClick={submitForm}
                                >
                                  Add
                                </button>
                              </Modal.Footer>
                            </div>
                          )}
                        </Formik>
                      </Modal>
                    </div> */}
                    <div className="col-md-4">
                      <label htmlFor="validationCustom15"></label>
                      <div className="input-group">
                      <TextField
                          id="standard-full-width"
                          placeholder="Enter Order Id"
                          fullWidth
                          margin="normal"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={searchTerm}
                          onChange={handleChangeSearchTerm}
                        />
                      </div>
                      {/* {document.getElementById("selectstatus").value} */}
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="validationCustom15"></label>
                      <div className="input-group">
                      <TextField
                          id="standard-full-width"
                          placeholder="Customer Name"
                          fullWidth
                          margin="normal"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={nameSearchTerm}
                          onChange={handleChangeNameSearchTerm}
                        />
                      </div>
                      {/* {document.getElementById("selectstatus").value} */}
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="validationCustom15"></label>
                      <div className="input-group">
                      <TextField
                          id="standard-full-width"
                          placeholder="Customer Phone"
                          fullWidth
                          margin="normal"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={phoneSearchTerm}
                          onChange={handleChangePhoneSearchTerm}
                        />
                      </div>
                      {/* {document.getElementById("selectstatus").value} */}
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="validationCustom15">Order Status</label>
                      <div className="input-group">
                        <select
                          name="status"
                          className="form-control"
                          value={statusname}
                          id="selectstatus"
                          required
                          onChange={(event) => {
                            setStatusValue(event.target.value);

                            // orderSearch();
                          }}
                        >
                          <option value="">ALL</option>
                          <option value="PENDING">PENDING</option>
                          <option value="PREPARING">READY TO SHIP</option>
                          <option value="DELIVERING">SHIPPED</option>
                          <option value="COMPLETED">COMPLETED</option>
                          <option value="CANCELED">CANCELED</option>
                        </select>
                      </div>
                      {/* {document.getElementById("selectstatus").value} */}
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="validationCustom15">Payment Method</label>
                      <div className="input-group">
                        <select
                          name="payment_method"
                          className="form-control"
                          id="selectPaymentmethod"
                          value={paymentMethod}
                          required
                          onChange={(event) => {
                            setPaymentMethodValue(event.target.value);
                          }}
                        >
                          <option value="">ALL</option>
                          <option value="PAYHERE">PAYHERE</option>
                          <option value="CASH_ON_DELIVERY">CASH ON DELIVERY</option>
                          <option value="BANK_DEPOSIT">BANK DEPOSIT</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="validationCustom15">Payment Status</label>
                      <div className="input-group">
                        <select
                          name="payment_status"
                          className="form-control"
                          id="selectPaymentstatus"
                          value={paymentStatus}
                          required
                          onChange={(event) => {
                            setPaymentStatusValue(event.target.value);
                          }}
                        >
                          <option value="">ALL</option>
                          <option value="PENDING">PENDING</option>
                          <option value="APPROVED">APPROVED</option>
                          <option value="CANCELED">CANCELED</option>
                          <option value="FAILED">FAILED</option>
                          <option value="CHANGEBACK">CHANGEBACK</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="validationCustom15"></label>
                      <div className="input-group">
                      <button
                          type="button"
                          className="btn btn-primary shadow-none"
                          onClick={clearFilters}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ms-panel-body">
                  {!reviewHide && <div className="row row-cols-md-4 justify-content-end mb-3">
                    <div className="col text-right">
                      {selectedItems && selectedItems.length > 0 ? (
                          <button
                            type="button"
                            className="btn btn-dark shadow-none w-100"
                            disabled={isSending}
                            onClick={handleClick}
                          >
                            Send Reviews({selectedItems.length})&nbsp;<i className="fa fa-paper-plane" aria-hidden="true"></i>
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-dark shadow-none"
                            disabled={true}
                          >
                            Send Review&nbsp;<i className="fa fa-paper-plane" aria-hidden="true"></i>
                          </button>
                      )}
                    </div>
                  </div>}
                  <div style={{flex: "100%" }}>
                    <DataGrid
                      rows={orders}
                      disableExtendRowFullWidth={false}
                      columns={columns}
                      pageSize={rowsPerPage}
                      pagination
                      autoHeight
                      hideFooter
                    />
                    <TablePagination
                      component="div"
                      count={count}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderNewtable;
